import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import { DEFAULTS } from "../../../Constant";

dayjs.extend(utc);
dayjs.extend(timezone);

const CustomDateTimePicker = (props) => {
  const timeZone = props.timeZone || DEFAULTS.TIME_ZONE;
  const valueInTz = props.value ? dayjs(props.value).tz(timeZone) : null;

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DemoContainer components={["DateTimePicker"]}>
        <DateTimePicker
          format="DD-MM-YYYY - hh:mm A"
          name={props.name}
          value={valueInTz}
          onChange={props.onChange}
          onBlur={props.onBlur}
          disabled={props.disabled}
          readOnly={props.readOnly}
          slotProps={{
            textField: {
              error:
                !!props.errorMsg ||
                (!!props.formik?.touched[props.name] &&
                  !!props.formik?.errors[props.name]),
              helperText:
                props.errorMsg ||
                (props.formik?.touched[props.name] &&
                  props.formik?.errors[props.name]),
              name: props.name,
            },
            actionBar: {
              actions: ["clear", "today", "accept"], // Enables Clear button
            },
          }}
        />
      </DemoContainer>
    </LocalizationProvider>
  );
};

export default CustomDateTimePicker;
